import React  from 'react';
import './App.css';
import './YearlyRevenue.css';
import DashboardLang from './DashboardLang.json';
import ReactTooltip from 'react-tooltip';
import YearlyRevenueToolbar from './YearlyRevenueToolbar.js';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import YearlyRevenueCustomTooltip from './YearlyRevenueCustomTooltip.js';

class YearlyRevenue extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			innerWidth: 0,
			innerHeight: 0,
			tab: "",
			currentYear: 0,
			currentMonth: 0,
			yearNumberArray: null,
			yearSelectedArray: null,
			yearValuesArray: null,
			showPopupMenu1YN: false,
			data: null,
			dashboardVariableListJsonObj: null,
			colorArray: ["#82ca9d", "#30ff30", "orange", "blue", "green", "red", "grey", "#ca829d", "#82ca9d", "#8884d8"],
			dashboardID: 0,
			dashboardUserType: -1,
		};
		
		this.updateDimensions = this.updateDimensions.bind(this);
		this.serverGetDashboardVariableList = this.serverGetDashboardVariableList.bind(this);		
		this.storeCurrentYear = this.storeCurrentYear.bind(this);		
		this.calcMonthsToDisplay = this.calcMonthsToDisplay.bind(this);
		this.setTab = this.setTab.bind(this);
		this.onClickYear = this.onClickYear.bind(this);
		this.renderHeaderOneYear = this.renderHeaderOneYear.bind(this);
		this.renderHeaderAllYears = this.renderHeaderAllYears.bind(this);
		this.renderOneBarTag = this.renderOneBarTag.bind(this);
		this.renderBarChart = this.renderBarChart.bind(this);		
		this.renderFooter = this.renderFooter.bind(this);
	}

	componentDidMount() {

		this.updateDimensions();
		
		var dashboardID = this.props.dashboardID;
		if (dashboardID > 0) {
			this.serverGetDashboardVariableList(dashboardID);
		}

		window.addEventListener('resize', this.updateDimensions);
	}
	
	componentDidUpdate() {

		var tab = this.state.tab;
		var dashboardAppUserType = this.props.dashboardAppUserType;
		var dashboardUserType = this.props.dashboardUserType;

		if (tab === "") {
			if (dashboardAppUserType > 0) {
				var toolbarVariableNameArray = this.getToolbarVariableNameArray();
				if (toolbarVariableNameArray.length > 0) {
					this.setState({tab: toolbarVariableNameArray[0]});
				}
			}
		}

		var selectedYear = this.state.selectedYear;
		var selectedMonth = this.state.selectedMonth;

		var dashboardID1 = this.state.dashboardID;
		var dashboardID2 = this.props.dashboardID;

		if (dashboardID1 !== dashboardID2) {

			if (dashboardID2 > 0) {
				this.serverGetDashboardVariableList(dashboardID2, selectedYear, selectedMonth);
			}
			
			this.setState({
				dashboardID: dashboardID2,
			});
		}

		var dashboardUserType1 = this.state.dashboardUserType;
		var dashboardUserType2 = this.props.dashboardUserType;
	
		if (dashboardUserType1 !== dashboardUserType2) {

			this.serverGetDashboardVariableList(dashboardID2, selectedYear, selectedMonth);

			this.setState({
				dashboardUserType: dashboardUserType2,
			});
		}
	}

	componentWillUnmount() {
		document.removeEventListener('resize', this.updateDimensions, true);
	};
	
	updateDimensions = () => {
		this.setState({ innerWidth: window.innerWidth, innerHeight: window.innerHeight });
	};
	
	getNewDashboardVariableListJsonObj(dashboardVariableListJsonObj1, dashboardUserType) {
		
		var i;
		var itemObj;
		var variableName;
		var dashboardVariableListJsonObj2 = [];
		var length = dashboardVariableListJsonObj1.length;
		var copyYN;
		
		for(i=0; i<length; i++) {

			itemObj = dashboardVariableListJsonObj1[i];
			variableName = itemObj.variableName;
			
			copyYN = false;

			// sales
			if (dashboardUserType === 1001) {
				copyYN = true;
			}
			
			// fb
			if (dashboardUserType === 1002) {
				if ((variableName === "rooms") || (variableName === "persons") || (variableName === "restaurantrevenue") || (variableName === "parking") || (variableName === "faultyrooms")) {
					copyYN = true;
				}
			}
			
			// housekeeping
			if (dashboardUserType === 1003) {
				if ((variableName === "rooms") || (variableName === "persons") || (variableName === "parking") || (variableName === "minibarrevenue") || (variableName === "faultyrooms")) {
					copyYN = true;
				}
			}
			
			// housemen
			if (dashboardUserType === 1004) {
				if ((variableName === "rooms") || (variableName === "persons") || (variableName === "parking") || (variableName === "faultyrooms")) {
					copyYN = true;
				}
			}
			
			if (copyYN) {
				dashboardVariableListJsonObj2.push(itemObj);
			}
		}
		
		return dashboardVariableListJsonObj2;
	}
	
	async serverGetDashboardVariableList(dashboardID) {

		var dashboardAppUserType = this.props.dashboardAppUserType;
		var dashboardUserType = this.props.dashboardUserType;
		
		if (dashboardAppUserType === 0) {
			return;
		}

		if ((dashboardAppUserType === 1) && (dashboardUserType === 0)) {
			return;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getdashboardvariablelist?dashboardid=" + dashboardID + "&variablefrequency=daily";
		
		var res = await fetch(url);
		var dashboardVariableListJsonObj = await res.json();
		
		var i;
		var itemObj;
		
		for(i=0; i<dashboardVariableListJsonObj.length; i++) {
			itemObj = dashboardVariableListJsonObj[i];
			itemObj.values = null;
		}

		if (dashboardUserType > 1000) {
			dashboardVariableListJsonObj = this.getNewDashboardVariableListJsonObj(dashboardVariableListJsonObj, dashboardUserType);
		}

		this.setState({
			dashboardVariableListJsonObj: dashboardVariableListJsonObj,
		});

		this.storeCurrentYear(dashboardVariableListJsonObj);
	}
	
	storeCurrentYear(dashboardVariableListJsonObj) {

		var currentYear;
		var currentMonth;

		var dateObj = new Date();
		currentYear = dateObj.getFullYear();		
		currentMonth = dateObj.getMonth() + 1;
		
		var i;
		var year;
		var yearNumberArray = [];
		var yearSelectedArray = [];
		var yearValuesArray = [];

		for(i=0; i<10; i++) {
			year = currentYear - 9 + i;
			yearNumberArray.push(year);
			yearValuesArray.push(null);
			if (i>7) {
				yearSelectedArray.push(true);
			} else {
				yearSelectedArray.push(false);
			}
		}
		
		this.setState({
			currentYear: currentYear,
			currentMonth: currentMonth,
			yearNumberArray: yearNumberArray,
			yearSelectedArray: yearSelectedArray,
			yearValuesArray: yearValuesArray,
		});

		this.calcMonthsToDisplay(dashboardVariableListJsonObj, this.state.tab, yearNumberArray, yearSelectedArray, yearValuesArray);
	}
	
	async calcMonthsToDisplay(dashboardVariableListJsonObj, variableName, yearNumberArray, yearSelectedArray, yearValuesArray) {

		var calcHelpersObj = this.props.calcHelpersObj;
		var dashboardVariableID = calcHelpersObj.getDashboardVariableIDFromVariableName(dashboardVariableListJsonObj, variableName);
		var i;
		var year;
		var month;
		var selectedYN;
		var jsonObj;
		var monthArray;
		var monthValue;
		var currentYear = this.state.currentYear;
		var currentMonth = this.state.currentMonth;
		
		if (dashboardVariableID > 0) {
			for(i=0; i<yearSelectedArray.length; i++) {
				selectedYN = yearSelectedArray[i];
				year = yearNumberArray[i];
				monthArray = [];
				if (selectedYN) {
					jsonObj = await calcHelpersObj.serverGetDashboardValueYear(dashboardVariableID, year);
					for(month=0; month<12; month++) {
						monthValue = calcHelpersObj.getMonthValue(currentYear, currentMonth, year, month+1, variableName, jsonObj);
						monthArray.push(monthValue);
					}
					yearValuesArray[i] = monthArray;
				}
			}
		}
		
		if (variableName === "roomrevenue") {
			for(i=0; i<yearSelectedArray.length; i++) {
				selectedYN = yearSelectedArray[i];
				year = yearNumberArray[i];
				monthArray = [];
				if (selectedYN) {
					jsonObj = await calcHelpersObj.calcRoomRevenueValueYear(dashboardVariableListJsonObj, year);
					for(month=0; month<12; month++) {
						monthValue = calcHelpersObj.getMonthValue(currentYear, currentMonth, year, month+1, variableName, jsonObj);
						monthArray.push(monthValue);
					}
					yearValuesArray[i] = monthArray;
				}
			}
		}

		if (variableName === "totalrevenue") {
			for(i=0; i<yearSelectedArray.length; i++) {
				selectedYN = yearSelectedArray[i];
				year = yearNumberArray[i];
				if (selectedYN) {
					monthArray = await calcHelpersObj.calcTotalRevenueValueYear(currentYear, currentMonth, dashboardVariableListJsonObj, year);
					yearValuesArray[i] = monthArray;
				}
			}
		}

		this.setState({
			yearValuesArray: yearValuesArray,
		});

		var j;
		var yearString;
		var monthString;
		var itemObj;
		var data = [];

		for(i=0; i<12; i++) {

			itemObj = {};
			monthString = this.props.getMonthStringShort(i+1);
			monthString = monthString.toUpperCase();
			itemObj.name = monthString;

			for(j=0; j<yearNumberArray.length; j++) {
				year = yearNumberArray[j];
				yearString = year.toString();
				selectedYN = yearSelectedArray[j];
				if (selectedYN){
					monthValue = yearValuesArray[j];
					itemObj[yearString] = monthValue[i];
				}
			}
			data.push(itemObj);
		}

		this.setState({
			data: data,
		});
	}
	
	getToolbarVariableNameArray() {

		var variableNameArray = [];
	
		var dashboardVariableListJsonObj = this.state.dashboardVariableListJsonObj;
		if (dashboardVariableListJsonObj === null) {
			return variableNameArray;
		}
		
		var i;
		var variableName;
		var itemObj;
		var skipVariableYN;
		var roomsYN = false;
		var roomPriceYN = false;

		for(i=0; i<dashboardVariableListJsonObj.length; i++) {
			itemObj = dashboardVariableListJsonObj[i];
			variableName = itemObj.variableName;
			if (variableName === "rooms") {
				roomsYN = true;
			}
			if (variableName === "roomprice") {
				roomPriceYN = true;
			}
		}

		var roomRevenueYN = false;
		if (roomsYN && roomPriceYN) {
			roomRevenueYN = true;
		}

		if (roomRevenueYN) {
			variableNameArray.push("roomrevenue");
		}
		
		for(i=0; i<dashboardVariableListJsonObj.length; i++) {

			itemObj = dashboardVariableListJsonObj[i];
			variableName = itemObj.variableName;
			
			skipVariableYN = false;
			if (variableName === "totalrooms") {
				skipVariableYN = true;
			}

			if (!skipVariableYN) {
				variableNameArray.push(variableName);
			}
		}

		var dashboardAppUserType = this.props.dashboardAppUserType;
		var dashboardUserType = this.props.dashboardUserType;

		if (dashboardUserType < 1000) {
			variableNameArray.push("totalrevenue");
		}

		return variableNameArray;
	}
	
	async setTab(tab) {

		this.setState({
			tab: tab,
		});

		this.calcMonthsToDisplay(this.state.dashboardVariableListJsonObj, tab, this.state.yearNumberArray, this.state.yearSelectedArray, this.state.yearValuesArray);
	}
	
	onClickYear(year) {
		
		var i;
		var year2;
		var selected;
		var yearSelectedArray = [];

		for(i=0; i<this.state.yearNumberArray.length; i++) {
			year2 = this.state.yearNumberArray[i];
			selected = this.state.yearSelectedArray[i];
			if (year === year2) {
				selected = !selected;
			}
			yearSelectedArray.push(selected);
		}

		this.setState({
			yearSelectedArray: yearSelectedArray,
		});

		this.calcMonthsToDisplay(this.state.dashboardVariableListJsonObj, this.state.tab, this.state.yearNumberArray, yearSelectedArray, this.state.yearValuesArray);
	}
	
	renderHeaderOneYear(year, selected) {
		
		var className = "";
		
		if (selected) {
			className = "YearlyRevenueTopHeaderOneYearSelected";
		} else {
			className = "YearlyRevenueTopHeaderOneYear";
		}
		
		return (
			<div key={year} className={className} onClick={() => this.onClickYear(year)}>{year}</div>
		);
	}

	renderHeaderAllYears() {
		
		var innerWidth = this.state.innerWidth;
		
		var yearStart = 0;
		if (innerWidth < 1000) {
			yearStart = 5;
		}

		var i;
		var rows = [];
		var year;
		var selected;

		for(i=yearStart; i<this.state.yearNumberArray.length; i++) {
			year = this.state.yearNumberArray[i];
			selected = this.state.yearSelectedArray[i];
			rows.push(this.renderHeaderOneYear(year, selected));
		}

		return (
			<div className="YearlyRevenueTopHeaderContainer">{rows}</div>
		);
	}
	
	renderOneBarTag(yearIndex) {

		var colorArray = this.state.colorArray;
		var color = colorArray[yearIndex];

		var year = this.state.yearNumberArray[yearIndex];
		var selectedYN = this.state.yearSelectedArray[yearIndex];

		if (!selectedYN) {
			return;
		}

		var yearString = year.toString();

		return (<Bar key={yearIndex} dataKey={yearString} fill={color} />);
	}
	
	renderBarChart() {
		
		var calcHelpersObj = this.props.calcHelpersObj;
		var tab = this.state.tab;
		var variableName = tab;
		var yearSelectedArray = this.state.yearSelectedArray;
		var dashboardVariableID = calcHelpersObj.getDashboardVariableIDFromVariableName(this.state.dashboardVariableListJsonObj, variableName);
		var i;
		var jsxCode;
		var jsxArray = [];
		
		var variableType = "int";
		var currencyYN = calcHelpersObj.isVariableCurrencyYN(variableName);

		if (dashboardVariableID > 0) {
			for(i=0; i<yearSelectedArray.length; i++) {
				jsxCode = this.renderOneBarTag(i);
				jsxArray.push(jsxCode);
			}
		}
		
		if (variableName === "totalrevenue") {
			for(i=0; i<yearSelectedArray.length; i++) {
				jsxCode = this.renderOneBarTag(i);
				jsxArray.push(jsxCode);
			}
		}
		
		if (variableName === "roomrevenue") {
			for(i=0; i<yearSelectedArray.length; i++) {
				jsxCode = this.renderOneBarTag(i);
				jsxArray.push(jsxCode);
			}
		}
		
		return (
			<ResponsiveContainer width="100%" height={400}>
				<BarChart
					width={500}
					height={400}
					data={this.state.data}
					margin={{
						top: 0,
						right: 20,
						left: 20,
						bottom: 5,
				}}
				>
					<XAxis dataKey="name" />
					<YAxis />
					<Tooltip content={
						<YearlyRevenueCustomTooltip
							variableType={variableType}
							currencyYN={currencyYN}
							getLang={this.props.getLang}
							getEURString={this.props.getEURString}								
						/>}
						cursor={false} 
					/>
					<Legend />
					{jsxArray}
				</BarChart>
			</ResponsiveContainer>
	  );
	}
	
	renderFooter() {

		var calcHelpersObj = this.props.calcHelpersObj;
		var i;
		var rows = [];
		var year;
		var selectedYN;
		var value;
		var valueString;
		var key2;
		var variableName = this.state.tab;
		
		var currencyYN = calcHelpersObj.isVariableCurrencyYN(variableName);

		var decimalPlaces = 0;
		var colorArray = this.state.colorArray;
		var monthArray;

		for(i=0; i<this.state.yearNumberArray.length; i++) {

			year = this.state.yearNumberArray[i];
			key2 = year + "-2";

			selectedYN = this.state.yearSelectedArray[i];

			if (selectedYN) {

				monthArray = this.state.yearValuesArray[i];
				value = 0;
				if (monthArray !== null) {
					value = calcHelpersObj.getYearValue(year, variableName, monthArray);
				}

				valueString = value;
				if (currencyYN) {
					valueString = this.props.getEURString(value, decimalPlaces);
				}

				var color = colorArray[i];
				var style = {color: color};

				rows.push(<div key={year} className="YearlyRevenueFooterItem1" style={style}>{year}</div>);
				rows.push(<div key={key2} className="YearlyRevenueFooterItem2" style={style}>{valueString}</div>);
			}
		}
		
		var yearLabel = this.props.getLang(DashboardLang, "year");

		return (
			<div className="YearlyRevenueFooterContainer">
				<div className="YearlyRevenueFooterDiv">
					<div className="YearlyRevenueFooterTitle1">{yearLabel}</div>
					<div className="YearlyRevenueFooterTitle2">Total</div>
					{rows}
				</div>
			</div>
		);
	}
	
	render() {

		if (this.state.yearNumberArray === null) {
			return;
		}

		var toolbarVariableNameArray = this.getToolbarVariableNameArray();

		return (
			<div className="YearlyRevenueTopContainer">
				<ReactTooltip
					type="info"
					multiline={true}
					delayShow={200}
				/>
				<YearlyRevenueToolbar
					dashboardID={this.props.dashboardID}
					dashboardName={this.props.dashboardName}
					dashboardAppUserType={this.props.dashboardAppUserType}
					dashboardUserType={this.props.dashboardUserType}
					dashboardVariableListJsonObj={this.state.dashboardVariableListJsonObj}
					tab={this.state.tab}
					toolbarVariableNameArray={toolbarVariableNameArray}					
					setTab={this.setTab}
					getLang={this.props.getLang}
				/>
				{this.renderHeaderAllYears()}
				{this.renderBarChart()}
				<div style={{height: "20px"}}></div>
				{this.renderFooter()}
				<div style={{height: "20px"}}></div>
			</div>
		);
	}
}

export default YearlyRevenue;

